<script lang="ts">
  import FullScreen from "./templates/FullScreen.svelte";
  import Dashboard from "./templates/Dashboard.svelte";
  import { location } from "svelte-spa-router";
  import { ApiService } from "./services/api.service";
  // import Notifications from 'svelte-notifications';
  ApiService.baseURL = process.env.API_URL;

  const fullscreens = ["/login", "/resetPassword"];
</script>

<div class="text-base-content">
  <!--
	<Notifications>
	-->
  {#if fullscreens.includes($location)}
    <FullScreen />
  {:else}
    <Dashboard />
  {/if}
  <!--
	</Notifications>
	-->
</div>

<style global lang="postcss">
  @tailwind base;
  @tailwind components;
  @tailwind utilities;

  :root {
    --custom-navbar-height: 60px;
    --custom-footer-height: 80px;
    --custom-main-padding: 2rem;
  }

  body {
    padding: 0;
    margin: 0;
    @apply bg-blue-50;
  }

  .main {
    min-height: calc(100vh - 60px - 80px);
  }

  .main--p {
    padding: var(--custom-main-padding);
  }

  .with--sidemenu {
    width: calc(100vw - 255px);
  }

  .limit-screen {
    height: calc(
      100vh - var(--custom-navbar-height) - var(--custom-footer-height) -
        var(--custom-main-padding) * 2
    );
  }
</style>
